<template>
    <form @submit.prevent="createType">
        <div>
            <label class="block mb-1" for="name">{{ $t('labels.name') }}</label>
            <InputText
                v-model="pt.name"
                name="name"
                type="text"
                placeholder="product type name"
                class="w-full"
                />      
                <p v-if="errors.name" class="text-sm text-danger">{{ errors.name[0] }}</p>          
        </div>
        <div class="mt-4">
            <Checkbox
                binary
                v-model="pt.hide" />
            <label class="ml-2" for="active">Hide product type from affiliates</label>
        </div>
        <div>
            <FileUpload :initial="{}" @upload="getImageId" />
        </div>
        <div class="flex justify-end mt-6">
            <button :disabled="loading" class="px-6 py-2 text-white rounded outline-none bg-secondary ring-0">
                <span v-if="loading">Loading</span>
                <span v-else>{{ $t('actions.create') }}</span>
            </button>
        </div>
    </form>
</template>

<script setup>
import { ref , defineEmits} from 'vue';
import ApiService from '@/services/ApiService';
import { toast } from 'vue3-toastify';
import FileUpload from '@/components/FileUpload.vue'

//prime vue components
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';

import { useRoute } from 'vue-router';

const emit = defineEmits(['created']);

const route = useRoute();

const pt = ref({
    name : '',
    image_id : '',
    product_id : route.params.id,
    hide : false
})
const errors = ref({});
const loading = ref(false);

const getImageId = (id) => {
    pt.value.image_id = id;
}

const createType = () => {
    loading.value = true;
    const id = toast.loading('Creating, please wait . . .');
    ApiService.post('product-types' , pt.value).then(() => {
        loading.value = false;
        toast.update(id, {
            render: "Created product type.",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            type: 'success',
            isLoading: false,
        });
        emit('created');
    }).catch((res) => {
        loading.value = false;
        toast.update(id, {
            render: "Error creating product type.",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            type: 'error',
            isLoading: false,
        });
        errors.value = res?.response?.data && res?.response?.data?.errors ? res?.response?.data?.errors : {};
    })
}
</script>

<style scoped>

</style>